import {collapseElement, expandElement} from "../Utils/Utils";

const MenuWorldwide = () => {

	const worldwide = document.querySelector('#worldwide');
	const mediaQuery = window.SVITZER21_Localize.mediaquery; // From theme-setup
	const subMenu = worldwide.querySelector('#menu-worldwide');

	// No touch devices
	worldwide.addEventListener('mouseover', (e) => {
		if(!Modernizr.touchevents && window.innerWidth >= mediaQuery.md) {
			worldwide.classList.add('js-reveal');
		}
	});
	worldwide.addEventListener('mouseleave', (e) => {
		if(!Modernizr.touchevents && window.innerWidth >= mediaQuery.md) {
			worldwide.classList.remove('js-reveal');
		}
	});

	// Touch devices
	worldwide.querySelector('.worldwide-toggler').addEventListener('click', (e) => {

		e.preventDefault();

		if(Modernizr.touchevents || window.innerWidth < mediaQuery.md) {
			if(worldwide.classList.contains('js-reveal')) {
				collapseElement(subMenu, () => {
					worldwide.classList.remove('js-reveal');
					worldwide.classList.add('js-conceal');
				});
			}
			else {
				expandElement(subMenu, () => {
					worldwide.classList.add('js-reveal');
				});
			}
		}
		else {
			worldwide.classList.toggle('js-reveal');
		}
	});

};

export default MenuWorldwide;